import IconV2 from './v2/IconV2.jsx';
import { FiAlertOctagon, FiAlertTriangle, FiInfo } from './react-icons/main';

const Note = ({ type, icon = true, text, link, size = 'md' }) => {
  const typeIcon = {
    info: FiInfo,
    warning: FiAlertTriangle,
    error: FiAlertOctagon
  }[type];

  return (
    <div className={`comp-note ${type} size-${size}`}>
      {!!icon && <IconV2 icon={typeIcon || icon} />}
      <span>{text}</span>
      {link && (
        <a href={link.url} target="_blank" rel="noreferrer" className="link">
          {link.text || 'Learn more'}
        </a>
      )}
    </div>
  );
};

export default Note;
